
import { useState } from 'react'
import ShortApp from './short-app'
import Disclaimer from './disclaimer'
import { Icon } from '../utils/Icons'

interface ShortAppContainerProps {
  close: () => void
  storeState: string
  storeId: number
}

const ShortAppContainer = (props: ShortAppContainerProps) => {
  const [disclaimerOpen, setDisclaimerOpen] = useState(true)

  return (
    <div
      sx={{
        width: '100%',
        position: ['absolute', 'absolute', 'absolute', 'relative'],
        top: 0,
        overflowY: ['scroll', 'scroll', 'scroll', 'visible'],
        backgroundColor: '#fff',
        zIndex: 5,
        height: ['100%', '100%', '100%', '100%'],
        transition: 'width 0.5s cubic-bezier(0, 1, 0, 1)',
        willChange: 'transform',
      }}
    >
      <div
        sx={{
          textAlign: 'right',
          padding: '20px',
          fontSize: '24px',
          cursor: 'pointer',
          position: 'relative',
          zIndex: 9,
          right: 0,
        }}
      >
        <Icon
          alt="Close Short App"
          name="times"
          tabIndex={0}
          width={24}
          height={24}
          fill="#000"
          onClick={() => props.close()}
        />
      </div>

      {disclaimerOpen &&
      (props.storeState == 'British Columbia' ||
        props.storeState == 'Ontario' ||
        props.storeState == 'Nova Scotia') ? (
        <div sx={{ px: '40px' }}>
          <Disclaimer
            storeState={props.storeState}
            setDisclaimerOpen={setDisclaimerOpen}
          />
        </div>
      ) : (
        <ShortApp
          close={props.close}
          storeState={props.storeState}
          storeId={props.storeId}
          setDisclaimerOpen={setDisclaimerOpen}
        />
      )}
    </div>
  )
}

export default ShortAppContainer
